<template>
  <section id="congratulations-section" class="section" style="overflow-x: visible;overflow-y: scroll; height: calc(100% -120px);" >
    <div class="columns is-centered is-vcentered is-multiline is-gapless">
      <div class="column is-3-desktop is-12-tablet is-hidden-mobile"></div>
      <div class="column is-6-desktop is-12-tablet is-12-mobile">
        <div class="container" style="height: 60vh;">
          <earth-animation :chosenLocation="chosenLocation" :companyLocation="companyLocation" />
        </div>
      </div>
      <div id="asd" class="column is-3-desktop is-12-tablet is-12-mobile">
        <div class="modal-card colored" id="sidebox-modal">
          <div class="modal-card-body helvetica">
            <p id="linea-separada" v-html="$t('NF3C1')" />
            <p>
              {{ $t('Puede visualizar en') }}
              {{ $t('este mapa interactivo') }}
              {{ $t('las diferentes opciones') }}
            </p>
          </div>

          <footer class="modal-card-foot">
            <button
              @click="$router.push({ name: 'onBoard.neofintech.phase3.info' })"
              class="button is-primary"
            >
              {{ $t('Continuar') }}
            </button>
          </footer>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import countriesCoordsDict from '@/constants/countries_coords_dict'
import EarthAnimation from '@/components/on-board/EarthAnimationResults.vue'

export default {
  mixins: [],
  methods: {},
  computed: {
    ...mapGetters('onBoard', ['neofintechData']),
    chosenLocation: function() {
      let self = this
      return {
        lat: this.$store.state.onBoard.neofintech.chosenLocation.lat,
        lng: this.$store.state.onBoard.neofintech.chosenLocation.lng,
        country: self.$t(this.$store.state.onBoard.neofintech.chosenLocation.country),
        locality: this.$store.state.onBoard.neofintech.chosenLocation.locality
      }
    },
    companyLocation: function() {
      let self = this
      const companyLocationId = this.$store.state.onBoard.neofintech.phase1
        .companyLocations[0]
      const companyLocation = countriesCoordsDict[companyLocationId]
      return {
        lat: (companyLocation && companyLocation.lat) || 0,
        lng: (companyLocation && companyLocation.lng) || 0,
        country: self.$t(self.$t(companyLocationId)),
        locality: self.$t(companyLocationId)
      }
    }
  },
  components: { EarthAnimation },

  data() {
    return {}
  }
}
</script>

<style lang="scss">
.modal-card {
  width: auto;
}
#congratulations-section {
  height: 100%;
  background: url('~@/assets/congrat-background.png');
  background-size: 80%;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f9f4ce;
}
</style>

<style scoped>
.modal-card-body {
  padding-top: 0;
}
.modal-card-body.helvetica p {
  margin-top: 20px;
}
#linea-separada {
  margin-top: 0;
}
#linea-separada::first-line {
  font-weight: bold !important;
  line-height: 60px;
  font-size: 1.1em;
}
</style>
